<template>
  <div class="game-tr-step" @click="showModal(stepData.index)">
    <!-- v-b-modal="'step_'+stepData.index"> -->
    <!-- <b-btn v-b-modal="'step_'+stepData.index">Show Modal</b-btn> -->
    <div :id="'step_' + stepData.index" class="stepp-button" :style="setConfig()">{{ stepData.id }}</div>
    <!-- Modal Component -->
    <b-modal
      size="lg"
      hide-footer
      hide-header
      v-model="show"
      :id="'step_' + stepData.index"
      :ref="'step_' + stepData.index"
      :title="stepData.title.text"
      @click="hideModal(stepData.index)"
      @hidden="close"
    >
      <div class="close-button-container" slot="modal-header-close">
        <button
          type="close"
          :title="getTooltips['close']"
          @click="close"
          name="close"
          class="close-button"
          :style="'width:' + 50 + 'px;height:' + 50 + 'px;top:' + 10 + 'px !important;left:' + 1728 + 'px!important;'"
        >
          <!-- <img src="~@/assets/icons/ic_close_white_64px.svg" />  --><svg
            fill="#ffffff"
            :height="50"
            viewBox="0 0 24 24"
            :width="50"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              fill="rgb(144, 144, 144)"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
      <div class="inner-modal-container" :style="setModalStyle(stepData)">
        <div
          class="image-container"
          v-if="stepData.header"
          :style="getImageStyle(stepData.header && stepData.header.imageData)"
        ></div>
        <div
          class="title-container"
          v-if="stepData.title"
          :style="setModalStyle(stepData.title)"
          v-html="stepData.title.text"
        ></div>
        <div
          class="text-container"
          v-if="stepData.textObj"
          :style="setModalStyle(stepData.textObj)"
          v-html="stepData.textObj.text"
        ></div>
      </div>
    </b-modal>
    <!-- <b-popover :target="'step_'+stepData.index"
             :ref="'step_'+stepData.index"
             :show.sync="show"
             triggers="click"
             :placement="stepData.direction">
    <div class="popover-body-step-text"
         v-html="stepData.textObj.text"
         :style="getStyle(stepData.textObj)"> </div>
  </b-popover> -->
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../../Utils/inputUtilsV2';
export default {
  name: 'tr-comics-v2',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    stepData: {
      type: null,
      default: function () {
        return {};
      },
    },
    showStep: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      // stepShowValue: this.showStep,
    };
  },
  created() {},
  mounted() {},
  methods: {
    showModal(index) {
      this.show = !this.show;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(
        {},
        this.getCustomStyle(imageData),
        {
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
        //  {
        //   // 'position': 'absolute',
        //   'background-image': 'url(\'static/' + imageData.imagePath + '\')',
        //   'top': [imageData.pos.y || 0, 'px'].join(''),
        //   'left': [imageData.pos.x || 0, 'px'].join(''),
        //   'width': [imageData.width || 1800, 'px'].join(''),
        //   'height': [imageData.height || 648, 'px'].join(''),
        // }
      );
    },
    setModalStyle(item) {
      return _.merge(
        //   {
        //   'width': '1800px',
        //   'height': '800px',
        //   'position': 'absolute',
        //   'left': '-514px',
        // }
        {},
        this.getCustomStyle(item)
      );
    },
    setConfig() {
      return {
        width: this.config.width + 'px',
        height: this.config.height + 'px',
        'font-size': this.config.fontSize + 'px',
        background: this.config.backgroundColor,
        color: this.config.color,
      };
    },
    getStyle(item) {
      item.width = item.width;
      item.height = item.height;
      return _.merge(this.getCustomStyle(item), {
        width: utils.elementWidth(item.width, 'px'),
        height: utils.elementHeight(item.height, 'px'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    close($event) {
      this.show = !this.show;
      this.$emit('close-modal', $event);
      // this.$store.commit('TOGGLE_MODAL_ACTIVE', false);
      // this.$store.commit('TOGGLE_UI_DISABLE', false);
    },
  },
  computed: {
    show: {
      get() {
        return this.showStep.show;
      },
      set(newValue) {
        // if (!newValue) {
        //   // this.$emit('change');
        //   this.$refs['step_' + this.stepData.id].$emit('close');
        // }
        this.showStep.show = newValue;
      },
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';

.game-tr-step {
  .stepp-button {
    border-radius: 100%;
    width: 45px;
    height: 45px;
    font-size: 29px;
    background: #f26f21;
    color: #fff;
    font-family: 'Calibri';
    font-weight: bold;
  }
}
</style>
<style lang="scss">
@import '~@/assets/sass/variable';
$aplaColor: #dde1ea;
// .popover.bs-popover-auto[x-placement^="top"] .arrow::after,
// .popover.bs-popover-top .arrow::after {
//     border-top-color: #f5f5dc !important;
//
// }
// .popover.bs-popover-auto[x-placement^="left"] .arrow::after,
// .popover.bs-popover-left .arrow::after {
//     border-left-color: #f5f5dc !important;
// }
// .popover.bs-popover-auto[x-placement^="right"] .arrow::after,
// .popover.bs-popover-right .arrow::after {
//     border-right-color: #f5f5dc !important;
// }
// .popover.bs-popover-auto[x-placement^="bottom"] .arrow::after,
// .popover.bs-popover-bottom .arrow::after {
//     border-bottom-color: #f5f5dc !important;
// }
.popover {
  // background-color: #f5f5dc;

  // .arrow::after {
  //
  // }
  .popover-body {
    font-size: 25px;
    font-family: Calibri;
    padding: 0;
    background-color: #f5f5dc;
    // padding: 0.5rem 0.75rem;
    .popover-body-step-text {
      padding: 0.5rem 0.75rem;
      background-color: #f5f5dc;
      // background-color: red;
    }
  }
}
.game-step-by-step-wrapper {
  .modal {
    z-index: 1050;
    .modal-header {
      z-index: 1060;
      padding: 34px;
      .close-button-container {
        z-index: 1060;
      }
    }
  }
  .modal-content {
    width: 1800px;
    height: 980px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    left: -514px;
    background-color: $aplaColor;
    .image-container {
      position: relative;
      display: flex;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .title-container {
      text-align: left;
      font-weight: bold;
    }
    .text-container {
      text-align: justify;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);

      .close-button {
        pointer-events: auto;
        opacity: 0;
        transition: opacity 4s ease;
      }
    }
    .close-button {
      pointer-events: auto;
      position: absolute;
      top: 0;
      right: 0;
      opacity: 1;
      z-index: 1003;
      cursor: pointer;
      outline: none;
      border: none;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      top: -47px !important;
      right: -50px !important;
      display: flex;
      transform: scale(1);
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      &:hover {
        svg {
          path:first-child {
            fill: #5d5d5d;
            transition: all 0.4s ease;
          }
        }
        background-color: $borderColor;
        // transform: scale(1.1);
        transition: all 0.4s ease;
        // opacity: 1;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
